var scrollPosition = require('../functions/scroll-position');

if (document.querySelector('.lazy-load')) {
	var $lazyLoadImage = document.querySelectorAll('.lazy-load'),
		loadImage = function() {
			for (let $image of $lazyLoadImage) {
				scrollPosition($image.offsetParent, function(reset) {
					let notLoaded = $image.classList.contains('lazy-load');

					if (notLoaded && !reset) {
						var srcPath = $image.dataset.src;

						$image.src = srcPath;
						setTimeout(function() {
							$image.removeAttribute('data-src');
							$image.classList.remove('lazy-load');
						}, 10);
					} 
				}, 1);
			}
		};

	window.addEventListener('scroll', loadImage);
	window.addEventListener('load', loadImage);
	window.addEventListener("orientationChange", loadImage);
}